// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__10NWP","alert":"SettungsInbox_alert__cYtbW"};